import React from 'react';
import Header from './Header';
import Team from './Team';
import Footer from './Footer';
import { useState, useEffect } from 'react';

const About = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      <Header isScrolled={isScrolled} />
      <main style={{ paddingTop: '120px' }}>
        <Team />
      </main>
      <Footer />
    </div>
  );
};

export default About;
